import template from './type-house.jade';
import houseType from '../../../enums/type-house';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.commonTypeHouse', []).directive('cianAfCommonTypeHouse', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.typeOptions = houseType;
      this.validation = validation(this.form, 'typeHouse', {
        required: 'Выберите тип дома',
      });
    },
  ],
  controllerAs: 'typeHouse',
  template,
})).name;
